import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    templateUrl: './eligibility-check.component.html',
    styleUrls: ['./eligibility-check.component.css']
})
export class EligibilityCheckComponent implements OnInit {
    partnerLogoUrl: string;
    backgroundUrl: string;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.route.data.subscribe((data) => {
            this.backgroundUrl = this.getAppropriateBackground(data.channelPartner.partnerMedia.background);
            this.partnerLogoUrl = data.channelPartner.partnerMedia.logo;
        });
    }

    private getAppropriateBackground(partnerBackgroundUrl: string) {
        const defaultBackgroundUrl = 'https://res.cloudinary.com/finzy/image/upload/v1590736709/backgrounds/pre-approval-home-page.jpg';
        return `url(${partnerBackgroundUrl ? partnerBackgroundUrl : defaultBackgroundUrl})`;
    }
}
